import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import { Poll } from './models/Poll';

export const getPollsState = (state: RootState) => state.polls;

export const selectPolls = createSelector(
  [getPollsState],
  (pollsState) => pollsState.polls.data
);

const isRenderableClassicPoll = (poll: Poll) =>
  Boolean(poll && !poll.governedConfiguration?.isGoverned &&
    typeof poll.questions?.[0]?.title === 'string');

export const selectClassicPolls = createSelector(
  [selectPolls],
  (polls) => polls.filter(isRenderableClassicPoll)
);

export const selectPoll = createSelector(
  [getPollsState],
  (pollsState) => pollsState.pollWithQuestionsList
);

export const selectPollLoading = createSelector(
  [getPollsState],
  (pollsState) => pollsState.pollWithQuestionsListLoading
);

export const selectPollsContinuationToken = createSelector(
  [getPollsState],
  (pollsState) => pollsState.polls.xMsContinuationToken
);

export const selectTotalPollCount = createSelector(
  [getPollsState],
  (pollsState) => pollsState.totalPollCount
);

export const selectLoadingSubmitPoll = createSelector(
  [getPollsState],
  (pollsState) => pollsState.loadingSubmitPoll
);

export const selectIsCreateNewPollDialogOpened = createSelector(
  [getPollsState],
  (pollsState) => pollsState.isCreateNewPollDialogOpened
);

export const selectFilteredPolls = createSelector(
  [getPollsState],
  (pollsState) => pollsState.filteredPolls.data
);

export const selectFilteredClassicPolls = createSelector(
  [selectFilteredPolls],
  (polls) => polls.filter(isRenderableClassicPoll)
);

export const selectFilteredPollsContinuationToken = createSelector(
  [getPollsState],
  (pollsState) => pollsState.filteredPolls.xMsContinuationToken
);

export const selectTotalFilteredPollCount = createSelector(
  [getPollsState],
  (pollsState) => pollsState.totalFilteredPollCount
);

export const selectLoadingFilteredPolls = createSelector(
  [getPollsState],
  (pollsState) => pollsState.loadingFilteredPolls
);

export const selectLoadingPolls = createSelector(
  [getPollsState],
  (pollsState) => pollsState.loadingPolls
);
export const selectNumberOfActivePolls = createSelector(
  [getPollsState],
  (pollsState) => pollsState.numberOfActivePolls
);

export const selectNumberOfClosedPolls = createSelector(
  [getPollsState],
  (pollsState) => pollsState.numberOfClosedPolls
);

export const selectPollSubmissionError = createSelector(
  [getPollsState],
  (pollsState) => pollsState.pollSubmissionError
);

export const selectEditedPoll = createSelector(
  [getPollsState],
  (pollsState) => pollsState.editedPoll
);

export const selectPollsError = createSelector(
  [getPollsState],
  (pollsState) => pollsState.pollsError
);
